import React from 'react';
import s from './Comments.scss';
import get from 'lodash.get';
import { Box, Text } from '@wix/design-system';
import { withTranslation } from '@wix/fe-essentials/i18n';
import ReactHtmlParser from 'react-html-parser';
const Comments = ({ t, metaData, footer, newMobileView = false, }) => {
    const notes = get(metaData, 'notes');
    const legalTerms = get(metaData, 'legalTerms');
    const firstLabel = get(footer, 'firstLabel');
    const secondLabel = get(footer, 'secondLabel');
    const formattedNotes = ReactHtmlParser(notes);
    const formattedLegalTerms = ReactHtmlParser(legalTerms);
    const firstLabelIfNeeded = () => {
        if ((firstLabel === null || firstLabel === undefined) && notes) {
            return t('invoice-view:price-quote.view.notes');
        }
        if (firstLabel && notes) {
            return firstLabel;
        }
        return null;
    };
    const secondLabelIfNeeded = () => {
        if ((secondLabel === null || secondLabel === undefined) && legalTerms) {
            return t('invoice-view:price-quote.view.legal-terms');
        }
        if (secondLabel && legalTerms) {
            return secondLabel;
        }
        return null;
    };
    return notes || legalTerms ? (React.createElement("div", null,
        !newMobileView && React.createElement("div", { className: s.divider }),
        React.createElement("div", { className: newMobileView ? '' : s.comments },
            React.createElement("div", { className: newMobileView ? '' : s.comment },
                React.createElement(Text, { size: "tiny", secondary: true, light: true, weight: "normal", dataHook: "notes-label" }, firstLabelIfNeeded()),
                newMobileView && React.createElement(Box, { paddingBottom: "6px" }),
                !!notes && (React.createElement(Text, { listStyle: "circle", size: "tiny", secondary: true, light: !newMobileView, dataHook: "notes-text" }, formattedNotes))),
            newMobileView && React.createElement(Box, { paddingBottom: "18px" }),
            React.createElement("div", { className: s.comment },
                React.createElement(Text, { size: "tiny", secondary: true, light: true, weight: "normal", dataHook: "legal-terms-label" }, secondLabelIfNeeded()),
                newMobileView && React.createElement(Box, { paddingBottom: "6px" }),
                !!legalTerms && (React.createElement(Text, { listStyle: "circle", size: "tiny", secondary: true, light: !newMobileView, dataHook: "legal-terms-text" }, formattedLegalTerms)))))) : null;
};
export default withTranslation(['invoice-view', 'locale-data'])(Comments);
//# sourceMappingURL=Comments.js.map